import React from 'react';
import { Game } from '../types/game';
import GameCard from './GameCard';
import './GameSection.css';

interface GameSectionProps {
  title: string;
  games: Game[];
  badge?: string;
  icon?: string;
  onFavoriteToggle?: (gameId: string) => void;
  onSeeAll?: () => void;
}

const GameSection: React.FC<GameSectionProps> = ({
  title,
  games,
  badge,
  icon,
  onFavoriteToggle,
  onSeeAll,
}) => {
  return (
    <section className="game-section">
      <div className="section-header">
        <div className="section-title-container">
          {badge && <span className="section-badge">{badge}</span>}
          {icon && <span className="section-icon">{icon}</span>}
          <h2 className="section-title">{title}</h2>
        </div>
        {onSeeAll && (
          <button className="see-all-button" onClick={onSeeAll}>
            SEE ALL
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </button>
        )}
      </div>
      <div className="games-grid">
        {games.map((game) => (
          <GameCard
            key={game.id}
            game={game}
            onFavoriteToggle={onFavoriteToggle}
          />
        ))}
      </div>
    </section>
  );
};

export default GameSection;

